module.exports = __webpack_public_path__ + "img/slideVerify_14.801088c2.png";